<template>
  <div class="center-top">
		<div class="center-item">
			<div
				class="icon"
				:style="{
					backgroundImage: `url(${require('../assets/home/qiwen.png')})`,
				}"
			></div>
			<div class="item-info">21°</div>
		</div>
		<div class="center-item">
			<div
				class="icon"
				:style="{
					backgroundImage: `url(${require('../assets/home/qing.png')})`,
				}"
			></div>
			<div class="item-info">白天</div>
		</div>
		<div class="center-item">
			<div
				class="icon"
				:style="{
					backgroundImage: `url(${require('../assets/home/time.png')})`,
				}"
			></div>
			<div class="item-info">{{ currentTime }}</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	data() {
		return {
			timer: null,
			currentTime: ""
		}
	},
	created() {
		this.startTimer()
	},
	beforeDestroy() {
    if (!this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
	methods: {
		startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          const now = moment();
          const datetime = now.format("YYYY-MM-DD HH:mm");
          const weekday = `星期${
            ["一", "二", "三", "四", "五", "六", "日"][now.isoWeekday() - 1]
          }`;
          this.currentTime = `${datetime} ${weekday}`;
          this.monitorTime = now.format("YYYY-MM-DD HH:mm");
        }, 1000);
      }
    },
	}
}
</script>

<style lang="scss" scoped>
 .center-top {
      width: 100%;
      height: 120px;
      display: flex;
      align-content: center;
      margin-top: 10px;
      .center-item {
        width: 227px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 28px;
        border-right: 2px solid;
        border-image: linear-gradient(
            0deg,
            rgba(49, 133, 200, 0) 0%,
            rgba(49, 133, 200, 0.99) 50%,
            rgba(49, 133, 200, 0) 100%
          )
          1;
        .icon {
          width: 40px;
          height: 40px;
          margin-right: 20px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }
      .center-item:last-child {
        max-width: 514px;
        flex: 1;
        border-right: none;
      }
    }
</style>